import { render, staticRenderFns } from "./ModificationHistoryDownloads.vue?vue&type=template&id=05ec0198&"
import script from "./ModificationHistoryDownloads.vue?vue&type=script&lang=js&"
export * from "./ModificationHistoryDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports